// extracted by mini-css-extract-plugin
export var closeButton = "_h3-1";
export var closeX = "_h3-3";
export var container = "_h3-0";
export var image = "_h3-2";